<div class="page">
  <div class="bar">
    <a class="back" routerLink="/">
      <svg class="back__arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M10 3 5 8l5 5"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Volver al inicio
    </a>

    <lc-theme-toggle />
  </div>

  <!-- ── Marca ────────────────────────────────────────────────────────────── -->
  <aside class="brand">
    <p class="brand__mark"><lc-logo variant="mark" [decorative]="true" /></p>

    <!-- La pila de folios avanza hacia el lector y el que llega al frente sale
         y vuelve al fondo: el expediente que siguió moviéndose mientras la
         sesión estaba cerrada. Es ilustrativa, no informativa. -->
    <div class="deck" aria-hidden="true">
      <article class="folio">
        <p class="folio__source">Folio 04 · SECOP II</p>
        <span class="folio__line" style="--w: 88%"></span>
        <span class="folio__line" style="--w: 62%"></span>
        <p class="folio__chip folio__chip--accent">Adenda 2 · cambió el cierre</p>
      </article>

      <article class="folio">
        <p class="folio__source">Folio 05 · Mercado Público</p>
        <span class="folio__line" style="--w: 76%"></span>
        <span class="folio__line" style="--w: 91%"></span>
        <span class="folio__line" style="--w: 48%"></span>
      </article>

      <article class="folio">
        <p class="folio__source">Folio 06 · ComprasMX</p>
        <span class="folio__line" style="--w: 84%"></span>
        <span class="folio__line" style="--w: 57%"></span>
        <p class="folio__chip folio__chip--ok">Documentación completa</p>
      </article>

      <article class="folio">
        <p class="folio__source">Folio 07 · SECOP II</p>
        <span class="folio__line" style="--w: 69%"></span>
        <span class="folio__line" style="--w: 88%"></span>
        <span class="folio__line" style="--w: 41%"></span>
      </article>

      <article class="folio">
        <p class="folio__source">Folio 08 · Mercado Público</p>
        <span class="folio__line" style="--w: 92%"></span>
        <span class="folio__line" style="--w: 66%"></span>
        <p class="folio__chip folio__chip--warn">Falta 1 anexo</p>
      </article>
    </div>

    <div class="brand__text">
      <p class="brand__eyebrow rise-1">Expediente en curso</p>
      <h1 class="brand__claim rise-2">Tus procesos siguieron corriendo sin ti.</h1>
      <p class="brand__promise rise-3">
        Entra y mira qué se movió: la adenda que llegó, el anexo que falta, el certificado que
        venció.
      </p>
    </div>

    <p class="sources">
      <span class="sources__label">Conectado a</span>
      <span class="sources__rule" aria-hidden="true"></span>
      <span>SECOP II</span>
      <span>Mercado Público</span>
      <span>ComprasMX</span>
    </p>
  </aside>

  <!-- ── Acceso ───────────────────────────────────────────────────────────── -->
  <main class="access">
    <section class="card">
      <h2 class="card__title rise-1">Vuelve al radar</h2>
      <p class="card__lead rise-2">Entra con la cuenta de trabajo que ya usas.</p>

      @if (error(); as message) {
        <p class="alert" role="alert">
          <svg class="alert__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <circle cx="10" cy="10" r="8.2" stroke="currentColor" stroke-width="1.5" />
            <path
              d="M10 6v4.6M10 13.6v.1"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
          </svg>
          <span>{{ message }}</span>
        </p>
      }

      <button
        type="button"
        class="provider provider--primary rise-3"
        [disabled]="busy()"
        [attr.aria-busy]="pending() === 'microsoft' ? true : null"
        (click)="microsoft()"
      >
        <span class="provider__glyph">
          @if (pending() === 'microsoft') {
            <span class="spin" aria-hidden="true"></span>
          } @else {
            <svg viewBox="0 0 23 23" aria-hidden="true">
              <path fill="#f25022" d="M1 1h10v10H1z" />
              <path fill="#7fba00" d="M12 1h10v10H12z" />
              <path fill="#00a4ef" d="M1 12h10v10H1z" />
              <path fill="#ffb900" d="M12 12h10v10H12z" />
            </svg>
          }
        </span>
        Continuar con Microsoft
        <span class="provider__tag">Recomendado</span>
      </button>

      <button
        type="button"
        class="provider rise-4"
        [disabled]="busy()"
        [attr.aria-busy]="pending() === 'google' ? true : null"
        (click)="google()"
      >
        <span class="provider__glyph">
          @if (pending() === 'google') {
            <span class="spin" aria-hidden="true"></span>
          } @else {
            <svg viewBox="0 0 48 48" aria-hidden="true">
              <path
                fill="#ea4335"
                d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
              />
              <path
                fill="#4285f4"
                d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
              />
              <path
                fill="#fbbc05"
                d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.28-3.14.76-4.59l-7.97-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
              />
              <path
                fill="#34a853"
                d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
              />
            </svg>
          }
        </span>
        Continuar con Google
      </button>

      <!-- ── Correo ────────────────────────────────────────────────────────
           Segundo camino, no un plan B escondido: quien no tiene cuenta de
           trabajo en Microsoft ni en Google entra por aquí. -->
      <p class="or rise-5"><span class="or__word">o</span></p>

      <form class="mail rise-5" (submit)="sendLink($event)" novalidate>
        <label class="vh" for="login-email">Correo de trabajo</label>
        <input
          id="login-email"
          class="mail__input"
          type="email"
          name="email"
          autocomplete="email"
          inputmode="email"
          placeholder="nombre@tuempresa.com"
          [value]="email()"
          [disabled]="busy()"
          (input)="onEmailInput($event)"
        />
        <button
          type="submit"
          class="mail__send"
          [disabled]="busy()"
          [attr.aria-busy]="pending() === 'email' ? true : null"
        >
          @if (pending() === 'email') {
            <span class="spin" aria-hidden="true"></span>
          }
          Enviarme un enlace
        </button>
      </form>

      <p class="status" role="status">
        @if (linkSentTo(); as address) {
          Te enviamos un enlace a {{ address }}. Ábrelo en este mismo navegador.
        } @else if (pendingLabel(); as label) {
          {{ label }}
        }
      </p>

      <p class="card__note rise-5">
        Si tu organización usa Microsoft 365, entra con Microsoft para habilitar los avisos en
        Teams.
      </p>
    </section>
  </main>
</div>
